import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  content: [],
  pageable: {},
  last: true,
  totalElements: 0,
  totalPages: 0,
  size: 10,
  number: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  empty: false,
};

export const BreakdownRequestDataReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.SET_BREAKDOWN_REQUESTS_DATA:
      return { ...state, ...payload };

    case ActionTypes.UPDATE_BREAKDOWN_PAGE:
      return { ...state, number: payload };

    case ActionTypes.UPDATE_BREAKDOWN_CONTENT:
      return { ...state, content: payload };

    default:
      return state;
  }
};
